// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 绑定个推设备 POST /common/login/bind_device */
export async function postCommonLoginBindDevice(
  body: API.BindDeviceParams,
  options?: { [key: string]: any },
) {
  return request<API.BindDeviceResult>('/common/login/bind_device', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 登录 POST /common/login/login */
export async function postCommonLoginLogin(
  body: API.LoginParams,
  options?: { [key: string]: any },
) {
  return request<API.LoginResult>('/common/login/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 退出登录 POST /common/login/logout */
export async function postCommonLoginLogout(
  body: API.LogoutParams,
  options?: { [key: string]: any },
) {
  return request<API.LogoutResult>('/common/login/logout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取登录验证码 POST /common/login/send_verify_code */
export async function postCommonLoginSendVerifyCode(
  body: API.SendVerifyCodeParams,
  options?: { [key: string]: any },
) {
  return request<API.SendVerifyCodeResult>('/common/login/send_verify_code', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 添加员工 POST /common/user/add_user */
export async function postCommonUserAddUser(
  body: API.AddUserParams,
  options?: { [key: string]: any },
) {
  return request<API.AddUserResult>('/common/user/add_user', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 注销 POST /common/user/destory_account */
export async function postCommonUserDestoryAccount(
  body: API.DestoryAccountParams,
  options?: { [key: string]: any },
) {
  return request<API.DestoryAccountResult>('/common/user/destory_account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取用户信息 POST /common/user/get_user_info */
export async function postCommonUserGetUserInfo(
  body: API.GetUserInfoParams,
  options?: { [key: string]: any },
) {
  return request<API.GetUserInfoResult>('/common/user/get_user_info', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 用户列表 POST /common/user/get_user_list */
export async function postCommonUserGetUserList(
  body: API.GetUserListParams,
  options?: { [key: string]: any },
) {
  return request<API.GetUserListResult>('/common/user/get_user_list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 用户筛选列表 POST /common/user/get_user_list_by_filter */
export async function postCommonUserGetUserListByFilter(
  body: API.GetUserListByFilterParams,
  options?: { [key: string]: any },
) {
  return request<API.GetUserListByFilterResult>('/common/user/get_user_list_by_filter', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 用户树形列表 POST /common/user/get_user_tree */
export async function postCommonUserGetUserTree(
  body: API.GetUserTreeParams,
  options?: { [key: string]: any },
) {
  return request<API.GetUserTreeResult>('/common/user/get_user_tree', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 离职员工 POST /common/user/quit_company */
export async function postCommonUserQuitCompany(
  body: API.QuitCompanyParams,
  options?: { [key: string]: any },
) {
  return request<API.QuitCompanyResult>('/common/user/quit_company', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 员工复职 POST /common/user/reset_user */
export async function postCommonUserResetUser(
  body: API.ResetUserParams,
  options?: { [key: string]: any },
) {
  return request<API.ResetUserResult>('/common/user/reset_user', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 设置员工离职后显示 POST /common/user/set_quit_show */
export async function postCommonUserSetQuitShow(
  body: API.SetQuitShowParams,
  options?: { [key: string]: any },
) {
  return request<API.SetQuitShowResult>('/common/user/set_quit_show', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 设置员工岗位 POST /common/user/set_role */
export async function postCommonUserSetRole(
  body: API.SetRoleParams,
  options?: { [key: string]: any },
) {
  return request<API.SetRoleResult>('/common/user/set_role', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 临时授权 POST /common/user/temporary_authorization */
export async function postCommonUserTemporaryAuthorization(
  body: API.TemporaryAuthorizationParams,
  options?: { [key: string]: any },
) {
  return request<API.TemporaryAuthorizationResult>('/common/user/temporary_authorization', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改密码 POST /common/user/update_password */
export async function postCommonUserUpdatePassword(
  body: API.UpdatePasswordParams,
  options?: { [key: string]: any },
) {
  return request<API.UpdatePasswordResult>('/common/user/update_password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
